import { initPlayground } from "./playground.js";
import { initWaves } from "./waves.js";
import { initShowcaseDuet } from "./showcase.js";
import { initExploreButton } from "./explore-button.js";
import { initCardGlow } from "./card-glow.js";
import { initFaqLit } from "./faq.js";

const main = () => {
    // Tail batch (D-footer): dynamic copyright year (progressive enhancement —
    // static fallback in HTML).
    const year = document.querySelector("#copyright-year");
    if (year !== null) {
        year.textContent = String(new Date().getFullYear());
    }

    // Slice 2: no steps section and no auto-cycle anywhere — playground is
    // user-driven only.
    initPlayground();

    // Part F motion: structural one-shots for the ported treatments.
    initShowcaseDuet();
    initExploreButton();
    initCardGlow();
    initFaqLit();

    // F1 (C2 winner): standing-wave dividers — three sine strokes per wave in
    // the original hues, fixed nodes with breathing amplitude so the shape
    // bobs in place. Wave-2 runs mirrored like the retired art.
    initWaves();
};

window.addEventListener("load", main);
